import { LedgersActivityReportRoute } from '../constants';
import { LedgerActivityReportUrlSearchValues } from '../schema';

export const useNavigateWithFilters = () => {
    const navigate = LedgersActivityReportRoute.useNavigate();
    const filterValues = LedgersActivityReportRoute.useSearch();

    return (
        values: Partial<LedgerActivityReportUrlSearchValues>,
        sortValue: LedgerActivityReportUrlSearchValues['sort']
    ) => {
        void navigate({
            search: {
                ...filterValues,
                ...values,
                sort: sortValue,
            },
        });
    };
};
